module.exports = __webpack_public_path__ + "images/factuals-icon-off-white_c79bbd8e4c7927e527ba51dbdd00b155.png";